import styled from "@emotion/styled";

import { Value } from "src/components/chatroom/Status/styles";

const StyledStatus = styled(Value)`
  text-overflow: inherit;
`;

export default StyledStatus;
